import React, { useEffect, useState } from "react";
import api from "../../api";
import ProduitsTable from "../../features/produits/components/ProduitsTable";
import ProduitsModal from "../../features/produits/components/ProduitsModal";
import ProduitsForm from "../../features/produits/components/ProduitsForm";
import ExportButton from "../../features/produits/components/ExportButton";
import SearchBar from "../../features/produits/components/SearchBar";
import { Plus, Package } from "lucide-react";
import { useAuth } from "../../context/AuthProvider";
import PageAnimator from '../../components/ui/PageAnimator';
import { Button } from "../../components/ui/button";

export default function Produits() {
  const { user } = useAuth();
  const [produits, setProduits] = useState([]);
  const [produitsFiltres, setProduitsFiltres] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [produitSelectionne, setProduitSelectionne] = useState(null);
  const [openFicheProduit, setOpenFicheProduit] = useState(false);
  const [openEdition, setOpenEdition] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchProduits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProduits = async () => {
    try {
      setIsLoading(true);
      const res = await api.get(`/produits`);
      setProduits(res.data.produits || []);
      setProduitsFiltres(res.data.produits || []);
    } catch (err) {
      console.error("Erreur lors de la recuperation des produits :", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4 sm:p-8 bg-workspace min-h-screen">
      <PageAnimator>
        {/* Header Premium */}
        <div
          className="
            relative z-20
            flex shrink-0 flex-col
            gap-6
            overflow-visible
            workspace-card
            bg-cover bg-center bg-no-repeat
            p-4 sm:p-6
            mb-6
            xl:flex-row xl:items-center xl:justify-between
          "
          style={{ backgroundImage: "url('/assets/backgrounds/lighthouse_bg.png')" }}
        >
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 z-0 rounded-[var(--hp-radius-lg)] bg-overlay"
          />

          {/* Gauche : Titre et Icone */}
          <div className="relative z-10 flex min-w-0 shrink-0 flex-col items-start gap-3 sm:flex-row sm:items-center sm:gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-secondary text-inverse shadow-hp-sm">
              <Package className="h-6 w-6" />
            </div>

            <div className="min-w-0">
              <h1 className="text-2xl font-bold text-inverse">
                Produits d'investissement
              </h1>
              <p className="mt-1 text-sm text-inverse opacity-80">
                Gerez votre catalogue de produits et leurs caracteristiques.
              </p>
            </div>
          </div>

          {/* Droite : SearchBar et Boutons */}
          <div className="relative z-10 flex flex-col sm:flex-row items-center gap-3 w-full xl:w-auto">
            <div className="w-full sm:w-64 shrink-0">
              <SearchBar produits={produits} setProduitsFiltres={setProduitsFiltres} />
            </div>

            <div className="flex items-center gap-2 w-full sm:w-auto justify-end">
              <ExportButton selectedRows={selectedRows} produits={produitsFiltres} />

              <Button
                variant="primary"
                onClick={() => {
                  setProduitSelectionne(null);
                  setOpenForm(true);
                }}
                className="shadow-hp-sm whitespace-nowrap"
              >
                <Plus className="h-4 w-4 mr-1.5" />
                Ajouter
              </Button>
            </div>
          </div>
        </div>

        {/* Tableau des produits */}
        <ProduitsTable
          produits={produitsFiltres}
          setSelectedRows={setSelectedRows}
          setProduitSelectionne={setProduitSelectionne}
          setOpenFicheProduit={setOpenFicheProduit}
          setOpenEdition={setOpenEdition}
          setOpenDeleteModal={setOpenDeleteModal}
          isLoading={isLoading}
          userRole={user?.Role}
        />

        {/* Fiche produit */}
        <ProduitsModal
          produitSelectionne={produitSelectionne}
          setProduitSelectionne={setProduitSelectionne}
          openFicheProduit={openFicheProduit}
          setOpenFicheProduit={setOpenFicheProduit}
          openEdition={openEdition}
          setOpenEdition={setOpenEdition}
          fetchProduits={fetchProduits}
          openDeleteModal={openDeleteModal}
          setOpenDeleteModal={setOpenDeleteModal}
        />

        {/* Formulaire produit */}
        <ProduitsForm
          open={openForm}
          setOpen={setOpenForm}
          produitSelectionne={produitSelectionne}
          fetchProduits={fetchProduits}
        />
      </PageAnimator>
    </div>
  );
}
